import { defineAsyncComponent } from 'vue';
import VueSplide from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const TopMissions = defineAsyncComponent(() => import('@/js/home/TopMissions.vue'));
const ActivityCenter = defineAsyncComponent(() => import('@/js/home/ActivityCenter.vue'));
const LatestNewsAndVideos = defineAsyncComponent(() => import('@/js/global/widgets/LatestNewsAndVideos.vue'));
const TopExchangesTippy = defineAsyncComponent(() => import('@/js/components/Tippy/TopExchangesTippy/TopExchangesTippy.vue'));
const ShareTippy = defineAsyncComponent(() => import('@/js/components/Tippy/ShareTippy/ShareTippy.vue'));

app.use(VueSplide);

app.component('TopMissions', TopMissions);
app.component('ActivityCenter', ActivityCenter);
app.component('LatestNewsAndVideos', LatestNewsAndVideos);
app.component('TopExchangesTippy', TopExchangesTippy);
app.component('ShareTippy', ShareTippy);

mountApp();
